export const pageSwiperEffect = {
  /**
   * "slide"（普通位移切换）
   */
  NORMAL: {
    effect: 'slide',
    fadeEffect: {}
  },
  /**
   * "fade"（淡入）
   */
  FADE: {
    effect: 'fade',
    fadeEffect: {
      crossFade: false
    }
  }
};
